export enum RecordingType {
  Recordings = 'RECORDING',
  Works = 'WORK'
}

export enum SortType {
  relevance = 'relevance',
  title = 'title',
  releaseYear = 'releaseYear',
  publishingPercent = 'publishingPercent',
  copyrightYear = 'copyrightYear',
  writer = 'writer',
  artist = 'artist',
  label = 'label',
  albumTitle = 'album',
  version = 'version'
}
